import axios from "axios";
import { useHistory } from "react-router-dom";
import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { fetchOrgCodeAndValidate } from "./indexedDBHelper";
import { toast } from "react-toastify";
const LicenseValidationForm = () => {
  const [licenseKey, setLicenseKey] = useState("");
  const [macAddress, setMacAddress] = useState("");
  const [error, setError] = useState("");
  const location = useLocation();
  const history = useHistory();

  const REACT_APP_BACKEND_ROUTE_URL = process.env.REACT_APP_BACKEND_ROUTE_URL;
  const [orgCode, setOrgCode] = useState("");
  const [appMode, setAppMode] = useState("");

  useEffect(() => {
    fetchOrgCodeAndValidate((data) => {
      if (data) {
        setOrgCode(data.org_code);
        setAppMode(data.app_mode);
      }
    });
  }, []);
  const { mac_address } = location.state || {}; // Read state safely

  useEffect(() => {
    console.log("Received State in AnotherComponent:", location.state);
    setMacAddress(`Mac Address : ${mac_address}`);
  }, [location.state]);

  console.log("Received Org Code:", orgCode);
  console.log("Received App Mode:", appMode);
  const handleLicenseChange = (e) => {
    let value = e.target.value.replace(/[^A-Za-z0-9]/g, "");
    value = value.substring(0, 16);
    let formattedValue = value.match(/.{1,4}/g)?.join("-") || "";
    setLicenseKey(formattedValue);
  };

  const handleMacChange = (e) => {
    let value = e.target.value.substring(0, 20); // Limit input to 20 characters
    setMacAddress(value);
  };

  const validateInputs = () => {
    const macValue = macAddress.replace("Mac Address : ", "").trim();
    let licenseError = "";
    let macError = "";

    if (licenseKey.length !== 19) {
      licenseError =
        "License Key must be in the format XXXX-XXXX-XXXX-XXXX (16 characters + dashes)";
    }

    if (!macValue) {
      macError = "MAC Address is required.";
    }

    setError(licenseError || macError);

    if (!licenseError && !macError) {
      // alert("Validation Successful!");
      console.log("License Key:", licenseKey);
      console.log("MAC Address:", macValue);
      validateLicense(licenseKey, macValue);
    }
  };
  const validateLicense = (licenseKey, macValue) => {
    const apiUrl = `${REACT_APP_BACKEND_ROUTE_URL}tenant_license_submission/`;

    const requestBody = {
      ORG_CODE: orgCode,
      APP_MODE: appMode,
      MAC_ADDRESS: macValue,
      LICENSE_KEY: licenseKey,
    };

    axios
      .post(apiUrl, requestBody, {
        headers: {
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        if (response.data.message === "Saved Successfully") {
          toast.success(response.data.message);
          setTimeout(() => {
            history.push("/login");
          }, 2000); // 2-second delay
          // history.push("/login")
        } else {
          toast.error(response.data.message);
        }
      })
      .catch((error) => {});
  };

  return ( 
    <div
      className="d-flex justify-content-center align-items-center"
      style={{
        height: "100vh",
        // backgroundImage: "url('/newImages/login_background.svg')",
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
      }}
    >
      <div
        className="card p-4 shadow-lg"
        style={{ width: "40%", minWidth: "400px", borderRadius: "10px" }}
      >
        <h4 className="text-center mb-4"> License Validation</h4>
        <form onSubmit={(e) => e.preventDefault()}>
          <div className="row">
            <div className="col-sm-12 col-md-12 col-lg-12 mb-3">
              <input
                style={{
                  borderColor:
                    error && error.includes("License Key") ? "red" : "",
                }}
                type="text"
                className="form-control"
                placeholder="License Key ( e.g. XXXX-XXXX-XXXX-XXXX )"
                value={licenseKey}
                onChange={handleLicenseChange}
                maxLength={19}
              />
            </div>
            <div className="col-sm-12 col-md-12 col-lg-12">
              <div className="form-group">
                <input
                  disabled
                  style={{
                    borderColor:
                      error && error.includes("MAC Address") ? "red" : "",
                  }}
                  type="text"
                  className="form-control"
                  placeholder="Server MAC Address"
                  value={macAddress}
                  onChange={handleMacChange}
                />
              </div>
            </div>
            <div className="col-md-12 text-center mt-3">
              {/* {error && <p style={{ color: "red" }}>{error}</p>} */}
              <button
                type="button"
                className="btn btn__secondary mt-10"
                onClick={validateInputs}
              >
                Validate
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

export default LicenseValidationForm;
